// extracted by mini-css-extract-plugin
export default {"policyLink":"utils_policyLink__7W2zI"};